import { render, staticRenderFns } from "./EducationalPeriodDelete.vue?vue&type=template&id=192d05a7&"
import script from "./EducationalPeriodDelete.vue?vue&type=script&lang=js&"
export * from "./EducationalPeriodDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports